// extracted by mini-css-extract-plugin
export default {"select_itemsWrapper":"styleInputSearch_select_itemsWrapper__ow+0w","select_item":"styleInputSearch_select_item__2RwV6"};